import { render } from "./VensysView.vue?vue&type=template&id=507e4c96&scoped=true&ts=true"
import script from "./VensysView.vue?vue&type=script&lang=ts"
export * from "./VensysView.vue?vue&type=script&lang=ts"

import "./VensysView.vue?vue&type=style&index=0&id=507e4c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507e4c96"]])

export default __exports__